import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { verifyEmailHandler } from '../../redux/slices/myAccount/verifyEmail-slice'
import { useSelector } from 'react-redux'

function VerifyEmail() {
    const { userId, token } = useParams()
    const verificationData = useSelector((state: any) => state?.verifyEmail?.data)
    const dispatch = useDispatch()
    useEffect(() => {
        if (userId && token) {
            dispatch(verifyEmailHandler(token) as any)
        }
    }, [userId, token])
    return (
        <div className='d-flex align-items-center justify-content-center '>{verificationData?.status === 200 && "Email Verified Successfully"}</div>
    )
}

export default VerifyEmail